import { useABTestVariable } from '../../../../hooks/useABTestVariable';
import { useCustomPreferences } from '../../../../utils/api';
import { CustomPreference } from '../../../../utils/api/CustomPreference';

export const useBopisSddFilterEnabled = (): {
    isBopisEnabled: boolean;
    isSddEnabled: boolean;
    isBopisOrSddEnabled: boolean;
} => {
    const isABTestEnabled = useABTestVariable<boolean>(
        CustomPreference.ENABLE_BOPIS_SDD_FILTERS_ON_PLP_SEARCH_PAGES,
        false,
    );

    const preferences = useCustomPreferences([
        CustomPreference.BOPIS_ENABLED,
        CustomPreference.SDD_ENABLED,
    ]);

    const isBopisEnabled = isABTestEnabled && !!preferences[CustomPreference.BOPIS_ENABLED];
    const isSddEnabled = isABTestEnabled && !!preferences[CustomPreference.SDD_ENABLED];
    const isBopisOrSddEnabled = isBopisEnabled || isSddEnabled;

    return { isBopisEnabled, isSddEnabled, isBopisOrSddEnabled };
};
